export const toPublicShareToken = (token: string): string => token.trim();
